// Where a live coding agent works on a board item (P-004): owners' boards load
// GET /api/workspaces/{ws}/fleet/working once and cards show "agent working · <machine>".
import { createContext, useContext } from 'react';
import { api, type FleetWorking } from '../api/client';
import { useLoad } from './useLoad';

export const AgentsContext = createContext<Map<string, FleetWorking>>(new Map());

/** The agent working on a card (by meta repo id and key), if any. */
export function useAgent(repoId: number, key: string): FleetWorking | undefined {
  return useContext(AgentsContext).get(`${repoId}:${key}`);
}

/** Owners: the items agents work on, keyed `repo_id:key`. Viewers: none (the fleet is owners'). */
export function useAgents(ws: number, owner: boolean): Map<string, FleetWorking> {
  const [res] = useLoad(
    async () =>
      owner
        ? api.GET('/api/workspaces/{ws_id}/fleet/working', { params: { path: { ws_id: ws } } })
        : { data: { items: [] as FleetWorking[] }, response: new Response(null) },
    `${ws}:${owner}`,
  );
  const items = res.state === 'ok' ? res.data.items : [];
  return new Map(items.map((i) => [`${i.repo_id}:${i.key}`, i]));
}
